<h2 mat-dialog-title>
  <span>Are you sure you want to withdraw?</span>
  <button mat-icon-button class="withdraw-dialog__close" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  <p class="withdraw-dialog__body">
    {{ body }}
  </p>

  <mat-radio-group [(ngModel)]="selectedReason" class="withdraw-dialog__options">
    <mat-radio-button *ngFor="let reason of reasons" [value]="reason" color="primary">
      {{ reason.reason }}
    </mat-radio-button>
  </mat-radio-group>

  <mat-form-field *ngIf="selectedReason?.requiresDetails" appearance="outline" class="withdraw-dialog__other">
    <mat-label>Please specify</mat-label>
    <textarea matInput [(ngModel)]="otherReason" rows="3" maxlength="1000"></textarea>
  </mat-form-field>

  <div class="withdraw-dialog__error" *ngIf="error">
    <mat-icon>error</mat-icon>
    <span>{{ error }}</span>
  </div>

  <div class="withdraw-dialog__actions">
    <button mat-stroked-button color="primary" (click)="close()" [disabled]="loading">Cancel</button>
    <button mat-flat-button color="primary" (click)="submit()" [disabled]="loading || !selectedReason || (selectedReason?.requiresDetails && !otherReason.trim())">
      Withdraw
    </button>
  </div>
</mat-dialog-content>
